var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.6109 9.7665C20.7286 19.8314 2.75351 23.8595 0.820404 9.76481C0.702244 -0.298394 18.6773 -4.32647 20.6109 9.7665Z",
    fill: "#2C5B47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6309 7.596L12.0864 7.08864L11.9287 6.92259C9.6333 9.09125 7.8706 10.8844 6.68945 12.2511C5.65429 13.4482 5.5747 13.7246 5.7832 13.9225C5.81738 13.9563 5.86865 14.005 5.98193 14.005C6.13134 14.005 6.38964 13.9192 6.8623 13.5962C7.28613 13.3078 7.56348 12.9923 7.69336 12.8247L7.69433 12.8254L10.3442 10.3554C10.5454 10.1675 12.7471 8.11368 12.9556 7.92121L12.6431 7.58469C12.6401 7.58706 12.6338 7.59307 12.6309 7.596ZM14.2778 5.98689C13.998 5.58491 13.3125 5.64841 12.9155 5.82266C12.7368 5.90173 12.3232 6.12331 12.3423 6.47533C12.353 6.66585 12.4819 6.76383 12.6064 6.85776C12.6685 6.90438 12.749 6.96579 12.8501 7.0584C12.981 7.17865 13.0513 7.26714 13.0996 7.32799C13.1719 7.41844 13.2534 7.52117 13.4194 7.53806C13.4341 7.53945 13.4482 7.54015 13.4624 7.54015C13.7598 7.54015 14.0439 7.2388 14.2021 6.97054C14.4199 6.599 14.4487 6.2308 14.2778 5.98689Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.28578df35b190e1c9b01e723bf70c55a.svg";
export { ForwardRef as ReactComponent };